import React, { useCallback, useState } from 'react'
import {
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  Link,
  Paper,
  Theme,
  Typography
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useTranslation } from 'react-i18next'
import ButtonComponent from '@professocial/professocialFormComponents/FormComponents/ButtonComponent'
import { getUser } from '../../../store/common/common.selectors'
import { useDispatch, useSelector } from 'react-redux'
import { UpdateUserAccountRequest } from '@professocialApi/professocial-core-frontend-api/apis/UserLoginRESTServiceApi'
import { updateUserAccountInitiated } from '../../../store/common/common.actions'
import { Link as RouterLink } from 'react-router-dom'

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    width: '100%',
    marginTop: theme.spacing(3),
    padding: theme.spacing(5),
  },
}))

const UserCommitment: React.FC = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const user = useSelector(getUser)
  const dispatchUpdateUserAccount = useCallback((params: UpdateUserAccountRequest) => dispatch(updateUserAccountInitiated(params)), [dispatch])

  const [checked, setChecked] = useState(false)
  
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked)
  }

  const handleButtonClick = async () => {
    if (!checked) return

    try {
      user?.id && dispatchUpdateUserAccount({ userId: user.id, userLogin: { ...user, commitmentsConfirmed: true } })

      setTimeout(() => {
        window.location.reload()
      }, 500)
    } catch (error) {
      console.error('Error updating user:', error)
    }
  }

  return (
    <Container maxWidth='lg'>
      <Grid container sx={{ px: 2, pb: 12 }}>
        <Paper className={classes.paper}>
          {/* HEADLINE */}
          <Typography variant='h3' fontWeight='bold' gutterBottom>
            {t('coreCommitment:headline')}
          </Typography>

          <br/>

          {/* BODY TEXT WITH LINK */}
          <Typography variant='body1' gutterBottom>
            {t('coreCommitment:commitmentText1')}
            <Link
              component={RouterLink}
              to={'/user/termsOfUse'}
            >
              <b>{t('coreCommitment:checkBoxLabelTermsOfUse')}</b>
            </Link>
            {t('coreCommitment:commitmentText2')}
          </Typography>

          <br/>

          {/* CHECKBOX WITH LABEL AND LINK */}
          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                onChange={handleCheckboxChange}
                color='primary'
              />
            }
            label={
              <>
                {t('coreCommitment:checkBoxLabel1')}
                <Link
                  component={RouterLink}
                  to={'/user/termsOfUse'}
                >
                  <b>{t('coreCommitment:checkBoxLabelTermsOfUse')}</b>
                </Link>
                {t('coreCommitment:checkBoxLabel2')}
              </>
            }
          />

          {/* BUTTON CENTERED & BELOW CONTENT */}
          <Grid container justifyContent='center' sx={{ mt: 3 }}>
            <ButtonComponent
              onClick={handleButtonClick}
              disabled={!checked}
              text={t('coreCommitment:continue')}
            />
          </Grid>
        </Paper>
      </Grid>
    </Container>
  )
}

export default UserCommitment

// https://chatgpt.com/c/6785401d-400c-8011-b659-3726f35e3607
